import { useEffect, useState } from "react";
import api from "@/lib/api";

const REGION_MONEDA = {
  US: "USD", GB: "GBP", CH: "CHF", RO: "RON", MD: "MDL", RU: "RUB", UA: "UAH", CN: "CNY", HK: "HKD", TW: "TWD",
  SA: "SAR", AE: "AED", QA: "QAR", KW: "KWD", MA: "MAD", DZ: "DZD", TN: "TND", EG: "EGP", JO: "JOD", TR: "TRY",
  MX: "MXN", AR: "ARS", CO: "COP", CL: "CLP", PE: "PEN", UY: "UYU", BO: "BOB", PY: "PYG", DO: "DOP", BR: "BRL",
  CA: "CAD", AU: "AUD", NZ: "NZD", PL: "PLN", CZ: "CZK", HU: "HUF", SE: "SEK", NO: "NOK", DK: "DKK",
  IN: "INR", JP: "JPY", KR: "KRW", SG: "SGD", ZA: "ZAR",
};

function monedaDelNavegador() {
  try {
    const loc = new Intl.Locale(navigator.languages?.[0] || navigator.language || "es");
    const region = loc.region || loc.maximize().region;
    return REGION_MONEDA[region] || null;
  } catch {
    return null;
  }
}

export function useMonedaVisitante() {
  const [eq, setEq] = useState(null);
  useEffect(() => {
    const currency = monedaDelNavegador();
    if (!currency) return;
    api.get("/fx/eur").then(({ data }) => {
      const rate = data?.rates?.[currency];
      if (rate) setEq({ currency, rate });
    }).catch(() => {});
  }, []);
  return eq;
}
